import { ChangeEvent, useEffect, useMemo, useRef, useState } from "react"
import LoaderComp from "../../loader/Loader"
import { MaterialReactTable, MRT_ColumnDef, useMaterialReactTable } from "material-react-table";
import { Link } from "react-router-dom";
import { useCVPageContext } from "../../context/cvPageContext";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
import { Button } from "@mui/material";
import { Tooltip, Typography, Divider } from '@mui/material';
import { useMsal } from "@azure/msal-react";
import { useCheckListContext } from "../../context/checkListContext";


function SemanticResults(props:any) {
    const { accounts } = useMsal();
    const [semanticResults, setSemanticResults] = useState<any[]>([]);
    const {checkList, setCheckList} = useCheckListContext();
    const [checkVersion, setCheckVersion] = useState(0);
    const [listTemp, setListTemp] = useState([]);
    const [timeElapsed, setTimeElapsed] = useState(false);
    const{
          codFiscP,
          setCodFiscP,
          setIsAIP,
          setUrlPDFP,
          setTimeCvsP,
          } = useCVPageContext();

    const toggleCheck = async (id: string) => {
      const userId = accounts[0]?.username;
      if (!userId) return;

      const isNowViewed = !checkList.includes(id);

      setCheckList((prev: any[]) =>
        isNowViewed ? [...prev, id] : prev.filter(f => f !== id)
      );

      setCheckVersion(v => v + 1);
    
      try {
        await fetch('/api/semanticCandidate/updateFlags', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId,
            candidateId: id,
            viewed: isNowViewed,
            valore: 'Sì'
          }),
        });
        
        setSemanticResults(prevData => prevData.map(item => item.Candidate_id === id ? {...item, visualized: 'Sì'} : item))
      } catch (err) {
        console.error("Errore nel salvataggio viewed:", err);
        // rollback
        setCheckList((prev: any[]) =>
          isNowViewed ? prev.filter(f => f !== id) : [...prev, id]
        );

        setCheckVersion(v => v + 1);
      }
    };

    const getBackgroundColorFromScore = (score: number) => {
      if (score === null || score === undefined) return '#eee'; 
      if (score >= 40) {
        // GIALLO (40) → VERDE (100)
        const ratio = (score - 40) / 60;
        const red = Math.round(255 - 255 * ratio);
        const green = 255; 
        return `rgb(${red},${green},0)`;
      } else {
        // ROSSO (0) → GIALLO (40)
        const ratio = score / 40; 
        const red = 255; 
        const green = Math.round(255 * ratio); 
        return `rgb(${red},${green},0)`;
      }
    };

    interface Semantic {
        Candidate_id: string;
        City: string;
        Giorni_alla_cancellazione: string;
        titolo_di_studio: string;
        // CV_red: string;
        // Ole_profile: string;
        profile: string;
        final_score: any;
        visualized: any;
        Stato_Candidato: string;
        Nome: string;
        Cognome: string;
        Provincia_Domicilio: string;
        Regione_Domicilio: string;
        Classe_Eta: string;
        data_ultima_attivita: Date;
        sl_bench: string;
        stato_collaboratore: string;
        email: string;
        cellulare: string;
        Ultimo_titolo_studio: string;
        ultima_valutazione_candidato: string;
        interviewer_name: string;
      }
    const columns = useMemo<MRT_ColumnDef<Semantic>[]>(
        () => [
          {
            accessorKey: 'visualized',
            header: 'Visualizzato (Sì / No)',
            size : 350,
            muiTableHeadCellProps: {
              align: 'center',
              sx: {
                textAlign: 'center',
                justifyContent: 'center',
                '& .MuiTableSortLabel-root': {
                  flexDirection: 'column',
                  justifyContent: 'center',
                },
                '& .MuiTableSortLabel-root .MuiTableSortLabel-icon': {
                  opacity: 1,
                }
              },
            },
            muiTableBodyCellProps: {
              align: 'center',
              sx: {
                textAlign: 'center',
              },
            },
            Cell: ({ cell,row }) => {
              const value = cell.getValue<number>();
              const color = getBackgroundColorFromScore(value);
              return (
                  <div>
                    <input type="checkbox" onChange={() => toggleCheck(row.original.Candidate_id)} checked={checkList.includes(row.original.Candidate_id)}></input>
                  </div>
                );
            },
          },
          {
            accessorKey: 'Nome',
            header: 'Nome',
          },
          {
            accessorKey: 'Cognome',
            header: 'Cognome',
          },
          {
            accessorKey: 'Candidate_id',
            header: 'ID Candidato',
          },
          {
            accessorKey: 'City',
            header: 'Città',
          },
          {
            accessorKey: 'Giorni_alla_cancellazione',
            header: 'Giorni alla cancellazione',
          }, 
          {
            accessorKey: 'Profile',
            header: 'Profilo Candidato',
            Cell: ({ cell }) => (
              <Tooltip 
                title={
                  (() => {
                    const text = cell.getValue() as string;
                    const boldWords = [
                      'Esperienza/Interesse',
                      'Competenze Professionali',
                      'Competenze Informatiche',
                      'Competenze Linguistiche',
                      'Certificazioni',
                      'Patenti di guida',
                      'Permesso di lavoro',
                      'Tipologia di contratto',
                      'Ambiente di lavoro',
                      'Competenze'
                    ];
                    
                    let formattedText = text;
                    boldWords.forEach(word => {
                      const regex = new RegExp(`(${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                      formattedText = formattedText.replace(regex, '<strong>$1</strong>');
                    });
                    
                    return (
                      <div 
                        style={{ 
                          whiteSpace: 'pre-line',
                          maxWidth: 700,
                          fontSize: '0.85rem',
                          fontWeight: 'normal'
                        }}
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                      />
                    );
                  })()
                } 
                placement="bottom"
                arrow
                PopperProps={{
                  placement: 'bottom',
                  modifiers: [
                    {
                      name: 'flip',
                      enabled: true,
                      options: {
                        fallbackPlacements: ['bottom', 'right', 'left', 'top'],
                        padding: 8,
                      },
                    },
                    {
                      name: 'preventOverflow',
                      enabled: true,
                      options: {
                        boundary: 'viewport',
                        padding: 8,
                      },
                    },
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 8],
                      },
                    },
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      maxHeight: '70vh',
                      overflow: 'auto',
                      backgroundColor: 'rgba(0, 0, 0, 0.9)',
                      '& .MuiTooltip-arrow': {
                        color: 'rgba(0, 0, 0, 0.9)',
                      }
                    }
                  }
                }}
              >
                <div style={{ 
                  maxWidth: 150,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'help'
                }}>
                  {cell.getValue() as string}
                </div>
              </Tooltip>
            ),
          },
          // {
          //   accessorKey: 'Profile',
          //   header: 'Profilo Candidato',
          //   Cell: ({ cell }) => (
          //     <div title={cell.getValue() as string}>
          //       {cell.getValue() as string}
          //     </div>
          //   ),
          //   muiTableBodyCellProps: {
          //     sx: {
          //       maxWidth: 150,
          //       overflow: 'hidden',
          //       textOverflow: 'ellipsis',
          //       whiteSpace: 'nowrap',
          //     },
          //   },
          // },
          {
            accessorKey: 'final_score',
            header: 'Score',
            muiTableHeadCellProps: {
              align: 'center',
              sx: {
                textAlign: 'center',
                justifyContent: 'center',
                '& .MuiTableSortLabel-root': {
                  flexDirection: 'column',
                  justifyContent: 'center',
                },
                '& .MuiTableSortLabel-root .MuiTableSortLabel-icon': {
                  opacity: 1,
                }
              },
            },
            muiTableBodyCellProps: {
              align: 'center',
              sx: {
                textAlign: 'center',
              },
            },
            Cell: ({ cell, row }) => {
              const value = cell.getValue<number>();
              const color = getBackgroundColorFromScore(value);
              return (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: color,
                        color: 'black',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        textAlign: 'center',
                        display: 'inline-block',
                        minWidth: '40px', // larghezza minima per il quadratino
                      }}
                    >
                      {value}
                    </div>
                  </div>
                );
            },
          },
          {
            accessorKey: 'Stato_Candidato',
            header: 'Stato Candidato',
          },
          {
            accessorKey: 'Provincia_Domicilio',
            header: 'Provincia Domicilio',
          },
          {
            accessorKey: 'Regione_Domicilio',
            header: 'Regione Domicilio',
          },
          {
            accessorKey: 'Classe_Eta',
            header: 'Classe di Età',
          },
          {
            accessorKey: 'data_ultima_attivita',
            header: 'Data Ultima Attività',
            Cell: ({ cell }) => {
              const rawDate = cell.getValue<Date>();
              return rawDate ? new Date(rawDate).toLocaleDateString('it-IT') : '';
            },
          },
          {
            accessorKey: 'email',
            header: 'Email',
          },
          {
            accessorKey: 'cellulare',
            header: 'Cellulare',
          },
          {
            accessorKey: 'Ultimo_titolo_studio',
            header: 'Ultimo Titolo di Studio',
          },
          {
            accessorKey: 'stato_collaboratore',
            header: 'Stato Collaboratore',
          },
          {
            accessorKey: 'ultima_valutazione_candidato',
            header: 'Ultima Valutazione Candidato',
            Cell: ({ cell }) => (
              <Tooltip 
                title={
                  (() => {
                    const text = cell.getValue() as string;
                    let formattedText = text;
                    
                    return (
                      <div 
                        style={{ 
                          whiteSpace: 'pre-line',
                          maxWidth: 700,
                          fontSize: '0.85rem',
                          fontWeight: 'normal'
                        }}
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                      />
                    );
                  })()
                } 
                placement="bottom"
                arrow
                PopperProps={{
                  placement: 'bottom',
                  modifiers: [
                    {
                      name: 'flip',
                      enabled: true,
                      options: {
                        fallbackPlacements: ['bottom', 'right', 'left', 'top'],
                        padding: 8,
                      },
                    },
                    {
                      name: 'preventOverflow',
                      enabled: true,
                      options: {
                        boundary: 'viewport',
                        padding: 8,
                      },
                    },
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 8],
                      },
                    },
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      maxHeight: '70vh',
                      overflow: 'auto',
                      backgroundColor: 'rgba(0, 0, 0, 0.9)',
                      '& .MuiTooltip-arrow': {
                        color: 'rgba(0, 0, 0, 0.9)',
                      }
                    }
                  }
                }}
              >
                <div style={{ 
                  maxWidth: 150,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'help'
                }}>
                  {cell.getValue() as string}
                </div>
              </Tooltip>
            ),
          },
          {
            accessorKey: 'interviewer_name',
            header: 'Intervistatore',
          },
        ],
        [checkVersion]
    )
    const data: Semantic[] = semanticResults
    const table = useMaterialReactTable({
        columns,
        data,
        initialState: { density: 'compact' },
        enableStickyHeader: true,
        muiTableContainerProps: {
          sx: { maxHeight: '500px' } 
        },
        columnResizeMode: 'onEnd',
        layoutMode: 'semantic',
        enableColumnResizing: true,
        enableRowActions: true,
        localization: {'actions':'Suggerimento'},
        positionActionsColumn: 'first',
        renderRowActions: ({ row }) => (
          <div>
            <Link to={`/cv?context=${encodeURIComponent(row.original.Candidate_id)}`} target="_blank" onClick={() => sendCodFisc(row.original.Candidate_id)}>
            <button type="submit" className="button-action-dir-sem" style={{width:"100px"}}>
              <h4>CV Candidato</h4>
            </button>
            </Link>
          </div>
      ),
      // renderTopToolbarCustomActions: () => (
      //   <div style={{ flex: 1 }}>
      //     <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', paddingRight: '16px' }}>
      //       <Button
      //         variant="contained"
      //         onClick={exportToExcel}
      //         sx={{
      //           backgroundColor: 'green',
      //           color: 'white',
      //           '&:hover': {
      //             backgroundColor: '#388e3c',
      //           },
      //           fontWeight: 'bold'
      //         }}
      //       >
      //         Esporta in Excel
      //       </Button>
      //     </div>
      //   </div>
      // ),
    });

    const sendCodFisc = (fiscale:any) => {
      setCodFiscP("");
      setUrlPDFP("");
      setIsAIP(false);
      setTimeCvsP(false);
      setCodFiscP(fiscale);
    }
    const getBack = () => {
        setSemanticResults([]);
        props.setIsResult(false);
    }
    const handleVectorResults = (dataPost:any) => {
        fetch(`/api/realtime/search_profile`, {
            method: 'POST',
            headers: { 'Accept': 'application/json',
                      "Content-Type": "application/json"},
            body: JSON.stringify(dataPost)})
            .then(response => response.json())
            .then(function(data){ 
            setSemanticResults(data)
            if (data.length === 0) {
                setTimeElapsed(true)
            }})
          console.log(semanticResults)
    }

    // const exportToExcel = () => {
    //   const ws = XLSX.utils.json_to_sheet(semanticResults);
    //   const wb = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, "SemanticResults");
    //   const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    //   const blob = new Blob([buf], { type: "application/octet-stream" });
    //   saveAs(blob, "semantic_results.xlsx");
    // };

    useEffect(() => {
      const userId = accounts[0]?.username;
      console.log(userId)

        if (semanticResults.length === 0) {
          handleVectorResults(props.dataPost);
          if (userId) {
        const fetchSeen = async () => {
          try {
            const res = await fetch(`/api/semanticCandidate/seen?userId=${userId}`);
            const data = await res.json();
            console.log(data)
            setCheckList(data);
            setCheckVersion(v => v + 1);
          } catch (err) {
            console.error('Errore nel fetch della checkList iniziale:', err);
          }
        };


        fetchSeen();

        
      }
        }
      }, []);
    return (
        <div className="containerTest">
            <div className='home-btn-slot-5'>
              <i className='bx bx-home bx-sm bx-border' id='home-btn' onClick={getBack}>
                <span className='home-btn-text-5'>
                  Torna alla schermata Home
                </span>
              </i>
            </div>
            {(semanticResults.length > 0 || timeElapsed)
            ?
              <div className="back">
                  <MaterialReactTable table={table}/>
              </div>
            :
              <div className="div-center">
                  <div>
                      <h3> Caricamento risultati ricerca semantica</h3>
                  </div>
                  <div style={{width:"100px", margin:"auto"}}>
                      <LoaderComp></LoaderComp>
                  </div >
              </div>
            }
        </div>
    )
}
export default SemanticResults
